import { createAction, createReducer } from "@reduxjs/toolkit";

import { ContractingSliceState, ContractingSyncPayload } from "./contracting-types";

export const initialState: ContractingSliceState = {
  lastKnownContractStates: {},
  hasContractChange: false,
};

export const syncContractingData = createAction<ContractingSyncPayload>("contracting/syncContractingData");
export const syncContractingDataSilent = createAction<ContractingSyncPayload>("contracting/syncContractingDataSilent");
export const acknowledgeAllContractingState = createAction("contracting/acknowledgeAll");

function buildContractStates(contracts: ContractingSyncPayload["contracts"]): Record<string, string> {
  const states: Record<string, string> = {};
  for (const contract of contracts) {
    const caregiverSignedAt = contract.parties?.caregiver?.signedAt?.toString() ?? null;
    const clientSignedAt = contract.parties?.client?.signedAt?.toString() ?? null;  
    states[contract.id] = contract.status + "__" + contract.type + "__" + caregiverSignedAt + "__" + clientSignedAt;
  }
  return states;
}

export const contractingReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(syncContractingData, (state, action) => {
      const { contracts } = action.payload;
      const contractStates = buildContractStates(contracts);

      // Detect contract status/signature changes
      // Skip change detection on first sync (no previous data)
      const hasPreviousData = Object.keys(state.lastKnownContractStates).length > 0;
      if (hasPreviousData) {
        for (const [id, newState] of Object.entries(contractStates)) {
          const previousState = state.lastKnownContractStates[id];
          if (!previousState || previousState !== newState) {
            state.hasContractChange = true;
            break;
          }
        }
      }
      state.lastKnownContractStates = contractStates;
    })
    .addCase(syncContractingDataSilent, (state, action) => {
      const { contracts } = action.payload;
      state.lastKnownContractStates = buildContractStates(contracts);
    })
    .addCase(acknowledgeAllContractingState, (state) => {
      state.hasContractChange = false;
    });
});
